import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, LinearProgress, linearProgressClasses, styled, Typography } from "@mui/material";
import theme from "../../theme";
import { ArrowDropDown, Check } from "@mui/icons-material";
import CommonButton from "../../common/components/CommonButton";
import { useNavigate } from "react-router-dom";
import CommonFeatureIcon from "../../common/components/CommonFeatureIcon";
import { useDispatch } from "react-redux";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { setLoading } from "../../features/authSlice";
import { getCounsellingTask } from "../../api/studentPerformanceApi";
import moment from "moment";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 6,
    borderRadius: 5,
    marginTop: 8,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: '#10AE2D',
        ...theme.applyStyles('dark', {
            backgroundColor: '#10AE2D',
        }),
    },
}));


const CounsellingTask = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [data, setData] = useState(null);

    const getCounsellingData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getCounsellingTask();
            setData(response.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        getCounsellingData();
    }, []);

    return (
        <Fragment>
            <CommonCard
                borderRadius={2}
                headerContent={
                    <Fragment>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ padding: '13px' }}
                        >
                            <Box>
                                <Typography fontWeight={600}>Counseling Tasks</Typography>
                                <Typography fontSize={14} color={theme.palette.background.dark}>Quick insights from counseling & tasks</Typography>
                            </Box>
                            <CommonButton
                                label="View More"
                                marginBottom="0px"
                                width="130px"
                                height="30px"
                                background={theme.palette.background.main}
                                color={theme.palette.background.dark}
                                borderRadius={3}
                                endIcon={<ArrowDropDown sx={{ color: theme.palette.background.dark }} />}
                                fontWeight={600}
                                handleClick={() => navigate('/my-dcp-counsellor')}
                            />
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Fragment>
                        <Grid container spacing={2} mb={2}>
                            <Grid item md={6}>
                                <CommonCard
                                    borderRadius={2}
                                    paddingBottom="0px"
                                    background="#FEF9C2"
                                    height="107px"
                                    content={
                                        <Fragment>
                                            <Box display="flex" justifyContent="space-between">
                                                <Box>
                                                    <Typography fontSize={20} fontWeight={600} color={theme.palette.primary.main}>{data?.completed} of {data?.total} Task</Typography>
                                                </Box>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    borderRadius: '50%',
                                                    background: 'white',
                                                    width: 40,
                                                    height: 40,
                                                    position: 'relative'
                                                }}>
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        borderRadius: '50%',
                                                        border: '1px solid #155DFC',
                                                        width: 18,
                                                        height: 18
                                                    }}>
                                                        <Check sx={{ color: '#155DFC', fontSize: 11 }} />
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Fragment>
                                    }
                                />
                            </Grid>
                            <Grid item md={6}>
                                <CommonCard
                                    borderRadius={2}
                                    paddingBottom="0px"
                                    background={theme.palette.secondary.main}
                                    content={
                                        <Fragment>
                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                <Box>
                                                    <Typography fontSize={15} color="white">Next Deadline</Typography>
                                                    <Typography fontSize={20} fontWeight={600} color={theme.palette.primary.main}>{data?.next_assignment ? moment(data?.next_assignment).format('MMM DD') : ''}</Typography>
                                                    <Typography fontSize={14} color="white">Early Action Deadline</Typography>
                                                </Box>
                                                <CommonFeatureIcon icon={<img
                                                    src='/Images/Calendar.png'
                                                    style={{
                                                        width: 20,
                                                    }}
                                                    alt=''
                                                />}
                                                    background="white"
                                                    height="45px"
                                                    width="45px"
                                                />
                                            </Box>
                                        </Fragment>
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Typography fontWeight={600} mt={1} mb={1}>Common App Progress:</Typography>
                        <Box
                            display="flex"
                            gap={1}
                            mt={1}
                        >
                            <BorderLinearProgress variant="determinate" value={data?.task_progress} sx={{ flexGrow: 1 }} />
                            <Typography fontWeight={600}>{data?.task_progress}%</Typography>
                        </Box>
                        {data?.completed_tasks?.length > 0 && data?.completed_tasks?.map((a) => (
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 1,
                                alignItems: 'center',
                            }}
                        >
                            <Box sx={{ background: 'green', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0.3 }}>
                                <Check sx={{ color: 'white', fontSize: 12 }} />
                            </Box>
                            <Typography fontSize={15}>{a?.title}</Typography>
                        </Box>
                        ))}
                    </Fragment>
                }
                paddingBottom="0px"
                padding="13px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default CounsellingTask;